import { memo, useMemo } from 'react';
import type {
  ReactElement,
} from 'react';

import styled from 'styled-components';

import { MenuItem } from './MenuItem';
import type {
  DropdownMenuDivider,
  DropdownMenuItemType,
} from './types';

const StyledMenu = styled.div(({
  theme: {
    indents,
  },
}) => ({
  paddingTop: indents.INDENT_1,
  paddingBottom: indents.INDENT_1,
}));

const DividerWrapper = styled.div(() => ({
  margin: '4px 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const Divider = styled.div(() => ({
  width: 'calc(100% - 24px)',
  backgroundColor: 'rgba(224, 224, 224, 1)',
  height: 1,
}));

export type MenuProps = {
  menu: DropdownMenuItemType[];
  close: () => void;
};

type DropdownMenuEntities = DropdownMenuItemType | DropdownMenuDivider;

function MenuInner({
  close,
  menu,
}: MenuProps): ReactElement {
  const menuWithDividers = useMemo(() => menu.reduce((accum: DropdownMenuEntities[], menuItem) => {
    accum.push(menuItem);

    if (menuItem.hasBottomDivider) {
      accum.push({ isDivider: true });
    }

    return accum;
  }, []), [menu]);

  return (
    <StyledMenu>
      {
        menuWithDividers.map((menuItem, index) => {
          if ('isDivider' in menuItem) {
            return (
              <DividerWrapper>
                <Divider />
              </DividerWrapper>
            );
          }

          return (
            <MenuItem
              menuItem={menuItem}
              close={close}
              key={index}
            />
          );
        })
      }
    </StyledMenu>
  );
}

export const Menu = memo(MenuInner);
